module.exports = __webpack_public_path__ + "/img/73efdb1fa5cfdd592040688436290dc9.png";